import { render } from "./SenaraiKiosk.vue?vue&type=template&id=6c8ea732"
import script from "./SenaraiKiosk.vue?vue&type=script&lang=js"
export * from "./SenaraiKiosk.vue?vue&type=script&lang=js"

import "./SenaraiKiosk.vue?vue&type=style&index=0&id=6c8ea732&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__